<template>
    <div class="ObjectListPage">
        <ObjectListHeaderPanel/>
        <div class="container">
            <div class="ObjectListPage__list" v-if="filteredAndSortingObjects.length">
                <ObjectList :objects="pageObjects"/>
            </div>
            <ObjectListNoResult v-else-if="globalFilter"/>
            <div class="ObjectListPage__pagination">
                <Pagination
                        v-if="pageCount > 1"
                        :page-count="pageCount"
                        v-model="currentPage"
                />
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>

import Pagination from "@/components/Pagination";
import ObjectList from "@/components/Object/ObjectList";
import Footer from "@/components/Footer";
import {mapGetters, mapState} from "vuex";
import ObjectListHeaderPanel from "@/components/ObjectListHeaderPanel";
import paginationObjects from "@/mixins/paginationObjects";
import ObjectListNoResult from "@/components/ObjectListNoResult";


export default {
    name: "ObjectListPage",
    mixins: [paginationObjects(4)],
    components: {
        ObjectListNoResult,
        ObjectList,
        Footer,
        Pagination,
        ObjectListHeaderPanel,
    },
    computed: {
        list(){
          return this.filteredAndSortingObjects;
        },
        ...mapState(['globalFilter']),
        ...mapGetters(['filteredAndSortingObjects'])
    }
}
</script>

<style lang="scss">
.ObjectListPage {

  &__list {
    padding-bottom: 40px;
  }

  &__pagination {

    @include mobile {
      display: flex;
      justify-content: center;
      overflow-x: auto;
    }
  }
}
</style>